<template>
    <div>
        <v-overlay
                id="form-overlay"
                opacity="1"
                data-qa="form-submission-overlay"
                class="thanks-overlay"
                :value="overlayShow">
            <v-row>
                <v-col
                        cols="12"
                        data-qa="form-submission-overlay-message"
                        v-html="overlayMessage" />
            </v-row>
        </v-overlay>
        <AccountHeader
                v-if="!embedded"
                :settings="accountSetting" />
        <v-row
                class="ma-0"
                dense>
            <v-col
                    cols="12"
                    dense>
                <v-card dense>
                    <v-card-title
                            class="heading-6 mb-0 pb-0"
                            align-text="center">
                        {{ form.title }}
                    </v-card-title>
                    <v-card-text>
                        <v-row
                                v-if="showConsumerData"
                                class="ma-4"
                                dense>
                            <v-col
                                    dense
                                    class="mb-2"
                                    cols="12" />
                            <v-col
                                    v-if="!hideConsumerField('first_name')"
                                    dense
                                    cols="6"
                                    class="ma-0 py-0">
                                <v-text-field
                                        v-model="contactDetails.first_name"
                                        class="ma-0 py-0"
                                        label="First name"
                                        :rules="requiredRules"
                                        :disabled="disableConsumerData" />
                            </v-col>
                            <v-col
                                    v-if="!hideConsumerField('last_name')"
                                    dense
                                    cols="6"
                                    class="ma-0 py-0">
                                <v-text-field
                                        v-model="contactDetails.last_name"
                                        class="ma-0 py-0"
                                        label="Last name"
                                        :rules="requiredRules"
                                        :disabled="disableConsumerData" />
                            </v-col>
                            <v-col
                                    v-if="!hideConsumerField('email')"
                                    dense
                                    cols="12"
                                    class="ma-0 py-0">
                                <v-text-field
                                        v-model="contactDetails.email"
                                        class="ma-0 py-0"
                                        label="Email address"
                                        :rules="requiredRules.concat(emailRules)"
                                        :disabled="disableConsumerData" />
                            </v-col>
                            <v-col
                                    v-if="!hideConsumerField('phone')"
                                    cols="12"
                                    dense
                                    class="ma-0 py-0 mt-2">
                                <MazPhoneNumberInput
                                        v-model="contactDetails.phone"
                                        class="ma-0 py-0 mb-4"
                                        size="md"
                                        :disabled="disableConsumerData"
                                        :default-country-code="timezone" />
                            </v-col>
                        </v-row>
                        <v-alert
                                v-if="form.header_text"
                                border="top"
                                colored-border
                                type="info"
                                elevation="2"
                                class="mt-4 pb-2">
                            {{ form.header_text }}
                        </v-alert>

                        <GroupComponent
                                v-for="(group, groupKey) in visibleGroups"
                                :key="groupKey"
                                ref="groups"
                                :group="group"
                                :group-key="groupKey"
                                :consumer="consumer"
                                @updateValue="updateValue"
                                @loading="setLoading" />
                        <v-row
                                v-if="form.footer_text"
                                dense>
                            <v-col cols="12">
                                <v-alert
                                        border="bottom"
                                        colored-border
                                        type="warning"
                                        elevation="2"
                                        class="caption">
                                    {{ form.footer_text }}
                                </v-alert>
                            </v-col>
                        </v-row>
                        <v-row
                                v-if="isSubmitable"
                                class="mt-4"
                                dense>
                            <v-col cols="12">
                                <v-btn
                                        :loading="!!loading"
                                        dark
                                        large
                                        class="align-center"
                                        data-qa="submit-btn"
                                        :style="{ color: accountSetting.button_text_color }"
                                        :color="(accountSetting.button_color) ? accountSetting.button_color : 'green'"
                                        @click="sendForm">
                                    Submit
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <PinComponent
                v-for="(pin, pinKey) in pins"
                :key="pinKey"
                ref="pins"
                :pin="pin"
                @pinConfirmed="pinConfirmed" />
        <v-dialog
                :value="unsavedChangesDialog"
                persistent
                max-width="340">
            <v-card>
                <v-card-title class="text-h5">
                    Form has not been submitted
                </v-card-title>
                <v-card-text>If you leave now, your response will not be sent.</v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                            color="red darken-1"
                            text
                            @click="unsavedChangesDialog(true)">
                        Leave
                    </v-btn>
                    <v-btn
                            color="darken-1"
                            text
                            @click="unsavedChangesDialog(false)">
                        Cancel
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<style>
.v-list-item__subtitle {
  white-space: normal !important;
}
.maz-phone-number-input .country-selector {
  flex: 0 0 7.7rem !important;
  width: 7.7rem !important;
  min-width: 7.7rem !important;
}
.maz-input__icon.right {
  right: 0.2rem !important;
}
.v-application {
  max-width: 1250px;
  margin: 0 auto;
  padding: 14px 0;
}

.v-application.embedded {
  max-width: 100% !important;
  width: 100% !important;
  margin: 0 !important;
  padding: 0 !important;
}

.v-application.embedded .ma-4 {
  margin: 8px 0 !important;
}

blockquote {
  border-left: 0.25em solid #dfe2e5;
  color: #c8cbcf;
  padding-left: 1em;
  margin: 20px 0!important;
}
.thanks-overlay {
  z-index: 100500 !important;
}
</style>
<script>
    import UnprocessableEntityError from "../../errors/unprocessableentity.error";
    import {MazPhoneNumberInput} from 'maz-ui'
    import "maz-ui/lib/css/index.css";
    import GroupComponent from "./components/GroupComponent";
    import PinComponent from "./components/PinComponent";
    import AccountHeader from "../AccountHeader";
    import {REGEXP_EMAIL, REGEXP_URL} from "@/models/field.model";
    import {TITLE} from "@/models/application.model";
    import UnsavedChangesChecker from "@/models/unsavedchangeschecker";
    import Session from "@/models/session.model";

    export default {
        name: "Form",
        components: {AccountHeader, PinComponent, MazPhoneNumberInput, GroupComponent},
        props: {
            embedded: {type: Boolean, default: false}
        },
        data() {
            return {
                submissionLoading: null,
                unsavedChangesDialog: null,
                unsavedChanges: new UnsavedChangesChecker(),
                allowToClosePopup: false,
                prevRoute: null,
                overlayShow: false,
                overlayMessage: '',
                conditions: [],
                filledForm: null,
                requiredRules: [
                    v => !!v || 'Field is mandatory'
                ],
                emailRules: [
                    v => !v || REGEXP_EMAIL.test(v) || 'E-mail must be valid'
                ],
                urlRules: [
                    v => !v || REGEXP_URL.test(v) || 'URL must be valid'
                ],
                loading: 0,
                translations: {
                    countrySelector: {
                        placeholder: ''
                    }
                }
            }
        },
        computed: {
            timezone() {
                return (new Session({})).currentTimezone
            },
            form() {
                return this.$store.forms.getForm();
            },
            documentTitle() {
                return this.form.title || TITLE;
            },
            consumer() {
                return this.$store.forms.getConsumer();
            },
            contactDetails() {
                return this.$store.forms.getContactDetails();
            },
            account() {
                return this.$store.forms.getAccount();
            },
            code() {
                return this.$store.forms.getCode();
            },
            accountSetting() {
                return this.$store.forms.getAccountSetting();
            },
            visibleGroups() {
                return this.form.groups;
            },
            pins() {
                return this.$store.fields.getPins();
            },
            showConsumerData() {
                return !!this.form.is_show_consumer_data &&
                    !(
                        this.hideConsumerField('first_name') &&
                        this.hideConsumerField('last_name') &&
                        this.hideConsumerField('phone') &&
                        this.hideConsumerField('email')
                    );
            },
            disableConsumerData() {
                return !!this.form.is_consumer_data_readonly;
            },
            isSubmitable() {
                return this.$route.name !== 'Preview' && this.$store.fields.isSubmitable();
            }
        },
        watch: {
            documentTitle(val) {
                document.title = val;
            }
        },
        beforeDestroy() {
            this.allowToClosePopup = false;
        },
        created() {
            document.addEventListener('visibilitychange', () => {
                document.title = document.visibilityState === 'hidden' ? 'Unsubmitted Form!' : this.documentTitle
            });

            window.addEventListener('message', (ev) => {
                try {
                    // To save on unnecessary processing - no need to check if message is for closing, so will not even parse when safe to close
                    if (this.unsavedChanges.haveUnsavedChanges() && !this.allowToClosePopup) {
                        if (typeof ev.data !== "string") {
                            return 1;
                        }
                        var message = JSON.parse(ev.data);
                        if (message.source === 'gappt' && message.action === 'urlPopupCloseCHK') {
                            // This will send response that will prevent closing of the popup
                            ev.source.postMessage(JSON.stringify({
                                source: 'gappt',
                                action: 'urlPopupCloseACK',
                                token: message.token
                            }), ev.origin);

                            this.resoleUnsavedChangesDialog().then((result) => {
                                if (result) {
                                    this.allowToClosePopup = true;
                                    ev.source.postMessage(JSON.stringify({
                                        source: 'gappt',
                                        action: 'urlPopupClose'
                                    }), ev.origin);
                                }
                            })
                        }
                    }
                } finally {
                //Nothing
                }
            });

            const loading = this.$services.modals.loading.show('Loading form');

            if (this.$route.name === 'FormByCode') {
                this.$store.forms.loadFormByCode(this.$route.params.code).then(() => {
                    this.init();
                }).catch(() => {
                    this.showOverlay('Error during loading. Contact support.')
                }).finally(() => {
                    loading.hide();
                })
            }

            if (this.$route.name === 'FormByLink') {
                this.$store.forms.loadFormByLink(this.$route.params.hash, this.$route.query.request, this.$route.query.consumer).then(() => {
                    this.init();
                }).catch(() => {
                    this.showOverlay('Unable to load the form. The form link may be invalid or expired.')
                }).finally(() => {
                    loading.hide();
                })
            }

            if (this.$route.name === 'Preview') {
                this.$store.forms.loadForPreview(this.$route.params.formId).then(() => {
                    this.init();
                }).catch(() => {
                    this.showOverlay('Error during loading. Contact support.')
                }).finally(() => {
                    loading.hide();
                })
            }
        },
        methods: {
            async resoleUnsavedChangesDialog() {
                const result = await new Promise((resolve, reject) => {
                    this.unsavedChangesDialog = resolve;
                    this.unsavedChangesDialogReject = reject
                })

                this.unsavedChangesDialog = null;
                return result;
            },
            hideConsumerField(field) {
                return this.form.groups.find((g) => {
                    return g.fields.find((f) => {
                        return f.consumer_label && f.consumer_label === field
                    })
                })
            },
            consoleUrl() {
                return process.env.VUE_APP_DATA_CAPTURE_CONSOLE_URL
                    .replace(
                        'ROOT_DOMAIN',
                        (process.env.VUE_APP_ROOT_DOMAIN || window.location.hostname)
                            .split('.')
                            .slice(-2)
                            .join('.')
                    );
            },
            appointmentRedirect() {
                if (this.$route.query.appointment) {
                    return this.consoleUrl() + 'appointment/' + this.$route.query.appointment
                } else {
                    return false;
                }
            },
            updateValue: function (groupId, fieldId, value) {
                this.$store.fields.saveValue(fieldId, value);
            },
            setLoading: function (value) {
                if (value) {
                    this.loading++;
                } else if (this.loading > 0) {
                    this.loading--;
                }
            },
            pinConfirmed: function (fieldId, value) {
                this.$store.fields.saveValue(fieldId, value);
                this.sendForm();
            },
            buildSendingRequest() {
                const body = {
                    forms: [{
                        id: this.form.id,
                        version: this.form.version,
                        fields: this.$store.fields.getFieldsForRequest()
                    }],
                    consumer: (this.showConsumerData) ? this.contactDetails : this.consumer.identifier,
                    link: this.$route.params.hash || null,
                    account: this.account,
                    code: (this.code) ? this.code.id : null,
                }

                if (this.$route.query.request) {
                    body.request = this.$route.query.request;
                }

                return body;
            },
            validate() {
                const promises = [];
                this.$refs.groups.forEach(group => promises.push(group.validate()));
                return Promise.all(promises)
            },
            pinConfirmation() {
                if (!this.$refs.pins) {
                    return true;
                }

                return this.$refs.pins.every((pin) => {
                    if (!pin.isConfirmed()) {
                        pin.openDialog();
                        return false;
                    }
                    return true;
                })
            },
            sendForm() {
                this.validate()
                    .then(() => {
                        this.$services.modals.alerts.hideAll();
                        if (!this.pinConfirmation()) {
                            return;
                        }
                        const sendingLoading = this.$services.modals.loading.show('Sending your answers...');
                        this.$services.forms.sendForm(this.buildSendingRequest())
                            .then((res) => {
                                setTimeout(() => {
                                    this.$services.submissions.getSubmission(res.data).then((res) => {
                                        this.handleSubmit(res.data.data).finally(() => sendingLoading.hide());
                                    });
                                }, 100)
                            })
                            .catch((error) => {
                                if (error instanceof UnprocessableEntityError) {
                                    this.showValidationErrors(error);
                                } else {
                                    this.showOverlay('Sending error')
                                }
                                sendingLoading.hide()
                            })
                    })
                    .catch((e) => {
                        this.$services.modals.alerts.error(e.message || e || 'System error')
                    })
            },
            async handleSubmit(submission) {
                this.$services.modals.loading.show('Saving your answers...');
                if (submission.status === 'success') {
                    this.successSubmit(submission);
                } else if (submission.status === 'failed') {
                    this.failedSubmit(submission);
                } else {
                    setTimeout(async () => {
                        let res = await this.$services.submissions.getSubmission(submission);
                        await this.handleSubmit(res.data.data);
                    }, 300)
                }
            },
            failedSubmit(submission) {
                this.$services.modals.loading.hideAll()
                this.$services.modals.alerts.error(submission.message || 'Submission failed! Please contact support: ' + submission.id)
            },
            successSubmit() {
                this.$services.modals.loading.hideAll()

                this.showOverlay(this.form.submitted_message || 'Thank you');

                const overlay = document.getElementById('form-overlay')
                overlay.style.backgroundColor = this.accountSetting.success_background_color;
                overlay.style.color = this.accountSetting.success_text_color;

                const overlayScrim = document.querySelector('#form-overlay .v-overlay__scrim');
                overlayScrim.style.backgroundColor = 'transparent';
                overlayScrim.style.opacity = 0;

                //reverse compatibility
                window.parent.postMessage('gappt_form_submitted', '*');
                window.parent.postMessage(JSON.stringify({source: 'gappt.forms', message: 'form.submitted', redirect: this.form.submitted_redirect_url}), '*');

                this.allowToClosePopup = true;

                if (this.embedded) {
                    return;
                }

                if (this.appointmentRedirect()) {
                    setTimeout(() => {
                        return window.location.href = this.appointmentRedirect();
                    }, 1000)
                }

                if (this.prevRoute) {
                    let prevRouteLocation = this.getLocation(this.prevRoute);
                    let consoleLocation = this.getLocation(this.consoleUrl());
                    if (prevRouteLocation && consoleLocation && prevRouteLocation.host === consoleLocation.host) {
                        setTimeout(() => {
                            return window.location.href = this.prevRoute;
                        }, 1000)
                    }
                }

                if (this.form.submitted_redirect_url) {
                    setTimeout(() => {
                        return window.location.href = this.form.submitted_redirect_url;
                    }, 1000);
                }

                if (this.code) {
                    setTimeout(() => {
                        return this.$router.push({
                            name: 'CodeAccess'
                        })
                    }, 1500)
                }
            },
            showValidationErrors(error) {
                if (error.response.data.errors) {
                    Object.entries(error.response.data.errors).forEach(([formKeyString, formErrors]) => {
                        let groupKeys = formKeyString.split('.');
                        let key = groupKeys[0];
                        if (key === 'consumer') {
                            formErrors.forEach(message => this.$services.modals.alerts.error(message));
                            return;
                        }
                        let groupKey = groupKeys[1];
                        formErrors.forEach((formError) => {
                            Object.entries(formError).forEach(([fieldKeyString, fieldErrors]) => {
                                fieldErrors.forEach((fieldError) => {
                                    Object.entries(fieldError).forEach(([,fieldErrorMessages]) => {
                                        let fieldKey = fieldKeyString.split('.')[1];
                                        let field = this.form.groups[groupKey].fields[fieldKey];

                                        fieldErrorMessages.forEach((message) => this.$services.modals.alerts.error(field.title + ' : ' + message));

                                        if (field) {
                                            let value = field.value;
                                            value.isValid = false;
                                            value.error = 'Invalid value';
                                            this.$store.fields.saveValue(field.id, value);
                                        }
                                    })
                                })
                            })
                        })
                    });
                }
            },
            showOverlay(message) {
                this.overlayMessage = message;
                this.overlayShow = true;
            },
            init() {
                if (!!this.form && !!this.form.id) {
                    this.$store.fields.loadStore(this.form);
                } else {
                    this.showOverlay('No need to fill out this form')
                }
            },
            getLocation(href) {
                return new URL(href);
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.prevRoute = vm.$route.query.redirect_url || '';
            })
        }
    }
</script>